import React from 'react';
import PropTypes from 'prop-types';

const AnimatedTitle = ({ title }) => {
  const arr = [];
  title.split('').map((element, i) => {
    return arr.push(<span key={i}>{element}</span>);
  });

  return <h1 className='welcome'>{arr}</h1>;
};

AnimatedTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AnimatedTitle;
